module.exports = __webpack_public_path__ + "img/fast-pay-out.9563a02a.jpg";